module.exports = __webpack_public_path__ + "img/fantom-logo.4fffbc21.svg";